import { Button } from '@/components/ui/button.tsx'
import { cn } from '@/lib/utils.ts'
import { openFile } from '@/utils/dom.ts'

interface DocumentThumbnailProps {
  url: string
  disableClick: boolean
  contentType?: string
}

export const DocumentThumbnail = ({ url, disableClick, contentType }: DocumentThumbnailProps) => {
  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (disableClick) return

    openFile(url, contentType)
  }

  return (
    <Button
      type="button"
      onClick={handleClick}
      disabled={disableClick}
      className={cn(
        'relative w-[60px] h-[60px] min-w-[60px] p-2 overflow-hidden rounded-none shrink-0 flex items-center justify-center bg-tb-grey-100',
        disableClick ? 'cursor-default' : '',
      )}
      aria-label="Document Attachment"
    >
      <img src="/images/file-icon.svg" alt="file" />
    </Button>
  )
}
